// extracted by mini-css-extract-plugin
export default {"buttonContainer":"ColumnButtonDownload_buttonContainer__zY6bO","buttonIcon":"ColumnButtonDownload_buttonIcon__16MaN"};